import { Library, FilePlus2, Landmark } from "lucide-react";
import AdminTabsHub from "@/pages/admin/AdminTabsHub";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminContentForm from "@/pages/admin/AdminContentForm";
import AdminCollections from "@/pages/admin/AdminCollections";

export default function AdminContentHub() {
  return (
    <AdminTabsHub
      idPrefix="content"
      title="Content"
      subtitle="Your knowledge library, the content editor and the sections/hub — all in one place."
      tabs={[
        { key: "library", label: "Content Library", icon: Library, render: () => <AdminDashboard /> },
        { key: "new", label: "Add Content", icon: FilePlus2, render: () => <AdminContentForm /> },
        { key: "sections", label: "Sections & Hub", icon: Landmark, render: () => <AdminCollections /> },
      ]}
    />
  );
}
